import request from '@/utils/request';
import { stringify } from 'qs';

export async function list(params) {
  return request(`/api/blade-interact/live-channel/page?${stringify(params)}`);
}

export async function info(params) {
  return request(`/api/blade-interact/live-channel/detail?${stringify(params)}`);
}

export async function getLiveChannels(params) {
  return request(`/api/blade-interact/school-famous/getLiveChannels?${stringify(params)}`);
}
